// extracted by mini-css-extract-plugin
module.exports = {"loadGame":"Statistics_loadGame__vuiy3","loadGame_header":"Statistics_loadGame_header__1TmLP"};